import { NotificationButton } from '@avanta/shared/components/Chat/NotificationButton';
import { SUPPORTER_ID } from '@avanta/shared/constants/chat';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { Headset } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { ROUTES } from 'constants/routes';
import { openInNewTab } from 'utils/common';

interface SupportButtonProps {
  className?: string;
  onAfterClick?: () => void;
  onInNewTab?: boolean;
}

export const SupportButton = ({
  className,
  onAfterClick,
  onInNewTab = false,
}: SupportButtonProps): React.ReactElement | null => {
  const navigate = useNavigate();
  const { t } = useTranslation(LOCIZE_NS.COMMON);

  const handleSupport = (): void => {
    if (onInNewTab) {
      openInNewTab(ROUTES.CHAT_SUPPORT);
    } else {
      navigate(ROUTES.CHAT, { state: { support: true } });
    }
    onAfterClick?.();
  };

  return (
    <NotificationButton
      variant="terciary"
      size="md"
      className={className}
      onClick={handleSupport}
      icon="leading"
      notificationUserId={SUPPORTER_ID}
    >
      <Headset className="size-5" />
      <p className="text-xs">{t('Nav.support')}</p>
    </NotificationButton>
  );
};
